export const environment = {
  production: true,

  backendServer: './otvoreni-grad'
};
